import type { ComponentProps } from "react";

import CrmEnrichmentJobRemoveModal from "../components/CrmEnrichmentJobRemoveModal/CrmEnrichmentJobRemoveModal";
import crmEnrichmentManageTrackingService from "../services/tracking/trackingService";
import type { CrmEnrichmentJob } from "../types/types";

type Props = Omit<ComponentProps<typeof CrmEnrichmentJobRemoveModal>, "jobName"> & {
    job: CrmEnrichmentJob;
};

const JobRemoveModalWithTracking = ({ job, onRemoveJob, ...props }: Props) => {
    const handleRemoveJobTracked = () => {
        crmEnrichmentManageTrackingService.trackRemoveJob(job, props.crmProvider);
        onRemoveJob();
    };

    return (
        <CrmEnrichmentJobRemoveModal
            {...props}
            jobName={job.name}
            onRemoveJob={handleRemoveJobTracked}
        />
    );
};

export default JobRemoveModalWithTracking;
